var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg005Accounting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 36 36",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    fill: "#274066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.8 34h-8.53a3.2 3.2 0 0 1 -3.2-3.2v-11.73a3.2 3.2 0 0 1 3.2-3.2h8.53a3.2 3.2 0 0 1 3.2 3.2v11.73a3.2 3.2 0 0 1 -3.2 3.2zm-8.53-16a1.07 1.07 0 0 0 -1.07 1.07v11.73a1.07 1.07 0 0 0 1.07 1.07h8.53a1.07 1.07 0 0 0 1.07-1.07v-11.73a1.07 1.07 0 0 0 -1.07-1.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.33 20.13h6.4v2.13h-6.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.33 24.4h2.13v2.13h-2.13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m27.6 24.4h2.13v2.13h-2.13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.33 27.6h2.13v2.13h-2.13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m27.6 27.6h2.13v2.13h-2.13z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m16.93 34h-11.73a3.18 3.18 0 0 1 -2.26-.94 3.22 3.22 0 0 1 -.94-2.26v-25.6a3.22 3.22 0 0 1 .94-2.26 3.18 3.18 0 0 1 2.26-.94h19.2a3.2 3.2 0 0 1 3.2 3.2v8.53h-2.13v-8.53a1.07 1.07 0 0 0 -1.07-1.07h-19.2a1.07 1.07 0 0 0 -1.07 1.07v25.6a1.07 1.07 0 0 0 1.07 1.07h11.73z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m6.27 7.33h7.11v2.13h-7.11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m6.27 12.67h10.67v2.13h-10.67z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m6.27 18h10.67v2.13h-10.67z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m6.27 23.33h5.93v2.13h-5.93z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m14.8 23.33h2.13v2.13h-2.13z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg005Accounting);
export default __webpack_public_path__ + "static/media/005-accounting.9c7eb36ea9719ac932be3e2d5321f69c.svg";
export { ForwardRef as ReactComponent };